module.exports = __webpack_public_path__ + "img/mama-o-kimchi_banner.e0baac51.jpg";